module.exports = __webpack_public_path__ + "static/media/otago_leaf.e8e1d74b.png";